'use client'

import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { Drawer, DrawerBody } from '@/ui/drawer/drawer/Drawer.client'
import type { ProductAnomaly } from '@gql-generated/graphql'
import { useAtom } from 'jotai'
import type React from 'react'
import { displayBobDrawerAtom } from '../../services/product.store'
import { BobForm } from './BobForm.client'

export type BobDrawerProps = {
  anomalies: Array<ProductAnomaly>
  reference: string
}

export function BobDrawer({ anomalies, reference }: BobDrawerProps): React.ReactElement | null {
  const { t } = useTranslation(['BobDrawer', 'generic'])
  const [isDrawerOpen, setIsDrawerOpen] = useAtom(displayBobDrawerAtom)

  if (!anomalies?.length) {
    return null
  }

  return (
    <Drawer
      isOpen={isDrawerOpen}
      onOpenChange={() => setIsDrawerOpen(false)}
      title={t('BobDrawer:title')}
    >
      <DrawerBody>
        <div className="flex flex-col gap-3">
          <BobForm anomalies={anomalies} reference={reference} />
        </div>
      </DrawerBody>
    </Drawer>
  )
}
